import { ErrorHandler, Injectable } from '@angular/core';

const CLAVE = 'gas-ultima-recarga-por-error';
const ESPERA_MS = 5 * 60 * 1000;

/**
 * Una pantalla abierta días sobrevive a varios deploys: si al navegar falta el
 * chunk de la versión con la que arrancó, la ruta no abre y nadie lo ve. Ante
 * ese error se recarga, como mucho una vez cada 5 min para no entrar en bucle.
 * El resto de los errores se loguea igual que el ErrorHandler de Angular.
 */
@Injectable()
export class RecargaErrorHandler extends ErrorHandler {
  override handleError(error: unknown): void {
    super.handleError(error);
    const msg = String((error as Error)?.message ?? error);
    if (/ChunkLoadError|dynamically imported module|Loading chunk/.test(msg)) {
      recargarSiCorresponde();
    }
  }
}

export function recargarSiCorresponde(): void {
  try {
    const ultima = Number(localStorage.getItem(CLAVE) ?? 0);
    if (Date.now() - ultima < ESPERA_MS) return;
    localStorage.setItem(CLAVE, String(Date.now()));
  } catch {
    // Sin storage no hay cómo frenar un bucle: no se recarga.
    return;
  }
  window.location.reload();
}
